// El cupo corresponde al día de uso del área, no al día de creación.
export const validateDailyReservationLimit = async (
  areaRef,
  area,
  reserva,
  excludedId
) => {
  if (Number(area.Periodo) !== 1) return

  const limit = Number(area.ReservaxUsuario)
  const start = new Date(reserva.Inicio?.toDate?.() || reserva.Inicio)
  if (
    !Number.isInteger(limit) ||
    limit < 1 ||
    !reserva.Usuario ||
    Number.isNaN(start.getTime())
  ) {
    throw new Error("No se pudo validar el límite diario de reservas.")
  }
  start.setHours(0, 0, 0, 0)
  const end = new Date(start)
  end.setDate(end.getDate() + 1)

  const snapshot = await areaRef
    .collection("reservaciones")
    .where("Inicio", ">=", start)
    .where("Inicio", "<", end)
    .get({ source: "server" })
  const count = snapshot.docs.filter(
    doc => doc.id !== excludedId && doc.data().Usuario === reserva.Usuario
  ).length
  if (count >= limit) {
    throw new Error(
      `El usuario ya alcanzó el límite de ${limit} reserva(s) para este día. Seleccione otro día.`
    )
  }
}
